export default "__VITE_ASSET__BTWciXLv__"